import { render, staticRenderFns } from "./nice-menu-context.vue?vue&type=template&id=44001932&scoped=true"
import script from "./nice-menu-context.vue?vue&type=script&lang=js"
export * from "./nice-menu-context.vue?vue&type=script&lang=js"
import style0 from "./nice-menu-context.vue?vue&type=style&index=0&id=44001932&prod&lang=sass"
import style1 from "./nice-menu-context.vue?vue&type=style&index=1&id=44001932&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44001932",
  null
  
)

export default component.exports